// extracted by mini-css-extract-plugin
module.exports = {"root":"accordion_root__1ITnv"};